export const THEME_CHROME_COLORS = {
  light: '#F3F5F9',
  dark: '#0C111D',
} as const;

export function syncDocumentThemeColor(theme: 'light' | 'dark'): void {
  if (typeof document === 'undefined') return;
  const content = THEME_CHROME_COLORS[theme];
  const existing = document.head.querySelectorAll('meta[name="theme-color"]');
  if (existing.length === 0) {
    const meta = document.createElement('meta');
    meta.setAttribute('name', 'theme-color');
    meta.setAttribute('content', content);
    document.head.appendChild(meta);
    return;
  }
  existing.forEach((meta) => {
    meta.setAttribute('content', content);
  });
}
